import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useUser } from "../../../../hooks/useUser";
import FilterSelector from "../../videos/adminVideosV2/filterSelector";
import { StoriesList } from "./StroiesList";
import { IconPlus } from "../../../../utils/icons";
import { Button } from "../../../../components/Button/Button";
import { CreateNewStory } from "./CreateNewStory";
import { IEmbed } from "./interface";
import { MainContainer } from "../../../../components/ContentWrapper";
import { PageTitle } from "../../../../components/PageTitle";
import { useFetchVideos } from "../../videos/hooks/useFetchVideos";

interface Props {
  loading: boolean;
  count: number;
  embeds: Array<IEmbed>;
  onDeleteEmbed: (i: number) => void;
  refetchEmbeds: () => void;
}
export function EmbedListV2({ refetchEmbeds, ...rest }: Props) {
  const [searchParams] = useSearchParams();
  const [createStory, setCreateStory] = useState(false);
  const navigate = useNavigate();

  const { brand } = useUser();
  const brandId: number = brand?.[0]?.id || 0;
  const { total: totalVideos, loading: videosLoading } = useFetchVideos("TDC", undefined, true);

  useEffect(() => {
    refetchEmbeds();
  }, [searchParams]);

  const props = { ...rest, brandId };
  return (
    <MainContainer>
      <div className="flex items-center justify-between min-h-[48px]">
        <PageTitle title="Stories" />
        <div className="flex items-center justify-between">
          <Button
            className="!flex gap-2 !px-4 mr-2"
            onClick={() => setCreateStory(true)}
            disabled={videosLoading || totalVideos === 0}
          >
            <IconPlus />
            <Typography>Create Story</Typography>
          </Button>
          {/* <Button
              className="!flex gap-2 !px-4"
              onClick={() => navigate("/projects/new")}
            >
              <IconPlus />
              <Typography>Create Project</Typography>
            </Button> */}
        </div>
      </div>
      <Box marginTop={6}>
        <FilterSelector isStories />
      </Box>
      <Box className="mt-8 flex gap-0">
        <Typography className="w-[110px] text-text-2">
          {rest.count} Stories
        </Typography>
        <div className="mt-3 border-t w-full border-border-token" />
      </Box>
      <Box className="mt-10">
        <StoriesList {...props} {...rest} />
      </Box>
      {createStory && (
        <CreateNewStory
          refetchEmbeds={refetchEmbeds}
          onClose={() => setCreateStory(false)}
        />
      )}
    </MainContainer>
  );
}
